import AutoComplateML from './AutoComplateML.jsx';

export default (props) => {
  return <AutoComplateML {...props} />;
};
